/**
 * Removes the session row matching `sessionId` from every cached library
 * items query (React Query infinite data from useGetLibraryItems). Does not
 * refetch.
 *
 * @param {import('@tanstack/react-query').QueryClient} queryClient
 * @param {{ sessionId: string|number }} params
 */
export function removeSessionFromLibraryCache(queryClient, { sessionId }) {
  if (!queryClient?.setQueriesData || sessionId == null) {
    return
  }

  const sessionKey = String(sessionId)

  queryClient.setQueriesData(
    {
      predicate: (query) => Array.isArray(query.queryKey)
        && query.queryKey[0] === 'libraryItems'
        && query.queryKey[1] === 'sessions',
    },
    (oldData) => {
      if (oldData == null || !Array.isArray(oldData.pages)) {
        return oldData
      }

      return {
        ...oldData,
        pages: oldData.pages.map((page) => ({
          ...page,
          items: (page.items || []).filter((item) => item != null && String(item.id) !== sessionKey),
        })),
      }
    },
  )
}
